export enum EModalType {
  Create = 'create',
  Edit = 'edit',
}

export enum EAssetsPageGetParams {
  Action = 'action',
}

export enum EAssetsPageGetParamsActionTypes {
  Create = 'create',
}
